module.exports = __webpack_public_path__ + "img/feresteh2.37df79a1.jpeg";